import React from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

export const withRouterUtilities = (BaseComponent) => {
  return (props) => {
    const navigate = useNavigate();
    const params = useParams();
    const searchParams = useSearchParams();
    const location = useLocation();

    return (
      <BaseComponent
        navigate={navigate}
        params={params}
        searchParams={searchParams}
        location={location}
        {...props}
      />
    );
  };
};
